import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { FormRuntimeContext } from '../form-renderer/FormRuntimeContext';

/**
 * Every CRM block uses the same tenant from the live form URL, defaulting to
 * the route's form tenant outside the renderer.
 */
export const useCrmTenant = (): string | undefined => {
  const { tenantId } = useParams<{ tenantId?: string }>();
  const { crmTenantId } = useContext(FormRuntimeContext);
  return crmTenantId || tenantId;
};
